/*
 * /context-suggestions/[suggestionId] (page)
 */
import { createFileRoute } from "@tanstack/react-router"
import {
	Container,
	Divider,
	Page,
	PageHeader,
	Skeleton,
} from "@psychology/react-ui"
import { ArrowLeft } from "lucide-react"
import { ContextSuggestionReview } from "../../features/context-suggestions/components/context-suggestion-review"
import { trpc } from "../../trpc"
import { authPageLoader } from "../../utils/auth.utils"

export const Route = createFileRoute("/context-suggestions/$suggestionId")({
	component: ContextSuggestionDetailPage,
	loader: authPageLoader,
})

function ContextSuggestionDetailPage() {
	const { suggestionId } = Route.useParams()
	const { user } = Route.useLoaderData()

	const {
		data: suggestion,
		isLoading,
		refetch,
	} = trpc.contextSuggestion.getByFilter.useQuery({
		where: { id: suggestionId },
	})

	const { data: currentContext, refetch: refetchContext } =
		trpc.psychologicalContext.getByFilter.useQuery({
			where: { userId: user.id },
		})
	const { data: persons, refetch: refetchPersons } =
		trpc.person.getAllByFilter.useQuery({ where: { userId: user.id } })
	const { data: userTraits, refetch: refetchTraits } =
		trpc.userTrait.getAllByFilter.useQuery({ where: { userId: user.id } })
	const { data: rollbackable } =
		trpc.contextSuggestion.getRollbackableId.useQuery()

	function handleChanged() {
		refetch()
		refetchContext()
		refetchPersons()
		refetchTraits()
	}

	if (isLoading) {
		return (
			<Page centerVertical={false}>
				<Container width={"xl"} padding={"lg"} gap={"sm"}>
					<Skeleton className={"h-8 w-48"} />
					<Divider />
					<Skeleton className={"h-40 w-full"} />
				</Container>
			</Page>
		)
	}

	if (!suggestion) {
		return (
			<Page centerVertical={false}>
				<Container width={"xl"} padding={"lg"} gap={"sm"}>
					<PageHeader
						title={"Suggestion not found"}
						left={{
							href: "/context-suggestions",
							label: "Suggestions",
							Icon: <ArrowLeft size={20} />,
						}}
					/>
				</Container>
			</Page>
		)
	}

	return (
		<Page centerVertical={false}>
			<Container width={"xl"} padding={"lg"} gap={"sm"}>
				<PageHeader
					title={"Review Suggestion"}
					left={{
						href: "/context-suggestions",
						label: "Suggestions",
						Icon: <ArrowLeft size={20} />,
					}}
				/>
				<Divider />
				<ContextSuggestionReview
					// Re-mount (resetting the local draft) whenever the stored row changes
					key={`${suggestion.id}-${String(suggestion.updatedAt)}`}
					suggestion={suggestion}
					currentContext={currentContext}
					persons={persons ?? []}
					userTraits={userTraits ?? []}
					rollbackableId={rollbackable?.id}
					onChanged={handleChanged}
				/>
			</Container>
		</Page>
	)
}
